import { jsx } from '@emotion/react';
import { Animation } from '../../../theme/Animation.es.js';
import { ColorsCSS } from '../../../theme/Colors.es.js';
import { Shadows } from '../../../theme/Shadows.es.js';
import '../../../theme/ZinniaStylesReset.es.js';
import { labelStyles, withModifier } from '@zapier/style-encapsulation';

const Styles = labelStyles("Surface", {
  root: (backgroundColor, shadow, borderColor) => [
    {
      borderRadius: "var(--zds-radius-medium, 5px)",
      transitionProperty: "box-shadow, border-color, background-color",
      transitionTimingFunction: Animation.transitionTimingFunction,
      transitionDuration: Animation.transitionDuration,
      alignItems: "stretch",
      flex: 1,
      maxWidth: "100%"
    },
    backgroundColor && withModifier(backgroundColor, {
      backgroundColor: ColorsCSS[backgroundColor]
    }),
    borderColor && withModifier(`border-${borderColor}`, {
      border: `1px solid ${ColorsCSS[borderColor]}`
    }),
    shadow && withModifier("hasShadow", {
      boxShadow: Shadows[shadow]
    })
  ]
});
const Surface = (props) => {
  const { backgroundColor = "transparent", shadow, borderColor } = props;
  return jsx("div", { css: Styles.root(backgroundColor, shadow, borderColor), "data-zds": true }, props.children);
};

export { Surface };
//# sourceMappingURL=Surface.es.js.map
